import { NewsUpdatesApiResponse } from '../../model/NewsUpdatesApiResponse'
import { CancelableRequestProducer } from '../common/types'
import { pg3ApiClient } from '../index'

export const fetchNews = (data: any): CancelableRequestProducer<NewsUpdatesApiResponse[]> => {
  return pg3ApiClient.get<NewsUpdatesApiResponse[]>('/news', {
    params: { ...data },
  })
}
